import React from 'react';
import ChecklistElement from './ChecklistElementModel';
import EditorType from '../../../Enums/EditorType';
import { Typography } from '@mui/material';
import type { JSX } from 'react';

class HeaderChecklistElement extends ChecklistElement {

    public constructor(elementId: string, name: string, itemNumber: string | null, sortNumber: number) {

        super(elementId, name, itemNumber, sortNumber, EditorType.HEADER);
    }

    public buildFormElement(primaryTextColor: string): JSX.Element {

        return (
            <React.Fragment key={this.elementId}>
                <Typography
                    variant='h6'
                    style={{
                        color: primaryTextColor,
                        fontWeight: 'bold',
                    }} 
                >
                    {this.name}
                </Typography>
                <br />
            </React.Fragment>
        );
    }
}

export default HeaderChecklistElement;